import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FareFamily } from '@fcom/dapi/api/models/fare-family';
import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models/finnair-itinerary-item-flight';
import { ElementTypes, GaContext } from '@fcom/common/interfaces/gtm.interface';

import { isByBusOnly } from '../../../utils/common-booking.utils';

@Component({
  selector: 'fin-fare-family-details',
  templateUrl: './fare-family-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./fare-family-details.component.scss'],
  standalone: false,
})
export class FareFamilyDetailsComponent implements OnChanges {
  readonly ElementTypes: typeof ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.FLIGHT_SELECTION;

  @Input()
  fareFamilies: FareFamily[];

  @Input()
  itineraries?: FinnairItineraryItemFlight[][];

  @Input()
  showKoreaNotification: boolean;

  @Input()
  hasWideBodyAircraft = false;

  hasBusLeg = false;

  ngOnChanges(): void {
    this.hasBusLeg = this.itineraries?.some((itineraries) => {
      return itineraries.some((itinerary) => isByBusOnly(itinerary));
    });
  }
}
